// extracted by mini-css-extract-plugin
export default {"banner":"bqdSFnPUxOQdGf8N8nzFg","text":"_6hpwmbnx5w3NxvXD0owz6i","cta":"_5zQ9f0FSJTncVK1KXZhZN0"};